import qs from 'qs';

const state = {
    group: {
        name: null,
        type: null,
        slug: null,
        can: {
            edit: false
        },
        categories: []
    },
    posts: [],
    activeCategory: null
}

// getters
const getters = {
    group: state => JSON.parse(JSON.stringify(state.group)),
    posts: state => state.posts,
}

// mutations
const mutations = {
    setGroup(state, group) {
        state.group = group;
    },
    clearGroup(state, group) {
        state.group = {
            name: null,
            type: null,
            slug: null,
            can: {
                edit: false
            }
        };
    },
    setActiveCategory(state, categorySlug) {
        if(state.group && state.group.categories){
            state.activeCategory = state.group.categories.find(cat => cat.slug === categorySlug);
        }
    },
    setActiveCategoryName(state, categoryName) {
        if(state.group && state.group.categories && state.activeCategory){
            state.activeCategory.name = categoryName;
        }
    },
    addCategory(state, category) {
        state.group.categories.push(category);
    },
    setPosts(state, posts) {
        state.posts = posts;
    },
}

// actions
const actions = {
    clearCache({commit}) {
        if( window.sessionStorage ){
            window.sessionStorage.removeItem('group:' + state.group.slug);
            window.sessionStorage.removeItem('group:' + state.group.slug + ':expires');
        }
    },
    getGroup({commit}, groupSlug) {
        if(
            window.sessionStorage && 
            window.sessionStorage.getItem('group:' + groupSlug) &&
            parseInt(window.sessionStorage.getItem('group:' + groupSlug + ':expires')) >= new Date().getTime()
        ){
            commit('setGroup', JSON.parse(window.sessionStorage.getItem('group:' + groupSlug)));
        }else{
            axios.get('/api/groups/' + groupSlug).then((response) => {

                commit('setGroup', JSON.parse(JSON.stringify(response.data) ));

                if(window.sessionStorage){
                    sessionStorage.setItem('group:' + groupSlug, JSON.stringify(response.data));

                    var current = new Date();
                    var expiryTime = new Date( current );
                    expiryTime.setMinutes( current.getMinutes() + 15 );

                    sessionStorage.setItem('group:' + groupSlug + ":expires", expiryTime.getTime());
                }

            }, (response) => {
                this.error = response;
            });
        }
    },
    getPosts({commit}, payload) {
        console.log(payload);

        var queryString = qs.stringify({
            category: payload.category
        });

        axios.get('/api/groups/' + payload.group + '/posts?'+ queryString).then((response) => {
            commit('setPosts', JSON.parse(JSON.stringify(response.data)));
        }, (response) => {
            this.error = response;
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}